import React from "react";

interface NumberBadgeProps {
    number: number;
}

const CSS_CLASS_NAME = "c-number-badge";

const NumberBadge = (props: NumberBadgeProps) => {
    const { number } = props;
    return <span className={CSS_CLASS_NAME}>{number}</span>;
};

export default NumberBadge;
